"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyAdministratorRequestDto = void 0;
class CompanyAdministratorRequestDto {
}
exports.CompanyAdministratorRequestDto = CompanyAdministratorRequestDto;
//# sourceMappingURL=company-administrator-request.dto.js.map